import {useEffect, useState} from 'react';

export type ThemeMode = 'light' | 'dark';

export const useTheme = () => {
    const [theme, setTheme] = useState<ThemeMode>(() => {
        const savedTheme = localStorage.getItem('theme') as ThemeMode;
        return savedTheme || 'light';
    });

    useEffect(() => {
        const root = window.document.documentElement;

        if (theme === 'dark') {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }

        localStorage.setItem('theme', theme);

        // Dispatch custom event for theme change
        window.dispatchEvent(new CustomEvent('theme-change', {detail: theme}));
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    };

    return {theme, setTheme, toggleTheme};
};
